import React, { useEffect, useState } from 'react';
import { Badge, Card } from 'reactstrap';
import { DataTableHead, DataTableItem, DataTableRow } from '../../../../../components/Component';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { addThreeDots, formatToSentenceCase } from '../../../../../utils/Utils';
import AuthTenantNoData from '../../../../error/AuthTenantNoData';
import * as app_consts from "../../../../../utils/app_consts";

const RecentPromotionEntries = ({ data, tenant_info }) => {

 const [pageData, setPageData] = useState(data);

 useEffect(() => {
  setPageData(data);
 }, [data]);


 return (
  <>
   <Card className="card-full">
    <div className="card-inner">
     <div className="card-title-group">
      <div className="card-title">
       <h6 className="title">Recent Entries</h6>
      </div>
     </div>
    </div>
    <div className="nk-tb-list mt-n2">
     <DataTableHead>
      <DataTableRow>
       <span>Promotion Name</span>
      </DataTableRow>
      <DataTableRow size="sm">
       <span>Participant</span>
      </DataTableRow>
      <DataTableRow size="md">
       <span>Entry</span>
      </DataTableRow>
      <DataTableRow>
       <span>Created On</span>
      </DataTableRow>
      <DataTableRow>
       <span className="d-none d-sm-inline">Status</span>
      </DataTableRow>
     </DataTableHead>
     {
      pageData ?
       pageData?.map((item, idx) => (
        <DataTableItem key={idx}>
         <DataTableRow>
          <span className="tb-lead">

           <Link to={`/${tenant_info.url_prefix}/orders/${item?.promotion?.id}`}>
            {item?.promotion?.name || "--"}
           </Link>
          </span>
         </DataTableRow>
         <DataTableRow size="sm">
          <div className="user-card">
           <div className="user-name">
            <span className="tb-lead">{item?.participant?.first_name ? addThreeDots(`${item?.participant?.first_name} ${item?.participant?.middle_name ? item?.participant?.middle_name : ""} ${item?.participant?.last_name ? item?.participant?.last_name : ""}`, 30) : "--"}</span>
           </div>
          </div>
         </DataTableRow>
         <DataTableRow size="sm">
          <div className="user-card">
           <div className="user-name">
            <span className="tb-lead">{item?.promotion_participant?.entry_code || "--"}</span>
           </div>
          </div>
         </DataTableRow>
         <DataTableRow size="md">
          <span className="tb-sub">{item?.promotion_participant?.inserted_at ? moment(item?.promotion_participant?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
         </DataTableRow>
         <DataTableRow>
          <Badge
           className="badge-dot badge-dot-xs"
           color={
            item?.promotion_participant?.code_status === app_consts.VALID ? "success" : "warning"
           }
          >
           {item?.promotion_participant?.code_status ? formatToSentenceCase(item?.promotion_participant?.code_status)?.toUpperCase() : "--"}
          </Badge>
         </DataTableRow>
        </DataTableItem>
       ))
       :
       <>
        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Entries Found"} />
       </>
     }
    </div>
   </Card>
  </>
 );
};

export default RecentPromotionEntries;